import React from 'react';

import CardLabelAndTitle from '../../../../components/CardLabelAndTitle';
import { CardDetails } from './BillsPaymentDetailsCard.data';

import './styles.scss';

const BillsPaymentDetailsCard = ({ payload }: any) => (
  <div className="wrapper">
    {CardDetails?.map(({ attribute, label, id }) => (
      <CardLabelAndTitle
        key={id}
        content={payload}
        attribute={attribute}
        label={label}
      />
    ))}
  </div>
);
export default BillsPaymentDetailsCard;
